export default __webpack_public_path__ + "static/media/seashell-box-open.0d951c4b.svg";